import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content-page" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}
const _hoisted_5 = {
  key: 2,
  class: "row"
}
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "card card-transparent card-block card-stretch card-height border-none" }
const _hoisted_8 = { class: "card-body p-0 mt-lg-2 mt-0" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-12 col-md-12" }
const _hoisted_13 = { class: "card card-block card-stretch card-height" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "d-flex align-items-center mb-4 card-total-sale justify-content-between" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "ms-3" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = {
  key: 0,
  class: "btn btn-primary view-btn font-size-14",
  "data-toggle": "modal",
  "data-target": "#new-order"
}
const _hoisted_20 = { class: "col-lg-8" }
const _hoisted_21 = { class: "col-lg-4" }
const _hoisted_22 = { class: "card card-block card-stretch card-height-helf" }
const _hoisted_23 = { class: "card-body card-item-right wallet-card" }
const _hoisted_24 = { class: "d-flex align-items-top" }
const _hoisted_25 = { class: "style-text text-left w-100" }
const _hoisted_26 = { class: "wallet-info" }
const _hoisted_27 = { class: "wallet-number mb-0" }
const _hoisted_28 = { class: "card-footer" }
const _hoisted_29 = { class: "card card-block card-stretch card-height-helf" }
const _hoisted_30 = { class: "card-body card-item-right" }
const _hoisted_31 = { class: "d-flex align-items-top" }
const _hoisted_32 = { class: "style-text text-left" }
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/auth-sign-in",
              class: "alert-link"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Sign in again")
              ])),
              _: 1
            })
          ]))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading dashboard...")
              ], -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, "Hi " + _toDisplayString(_ctx.user?.first_name || "User") + ", Good Morning", 1),
                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-0 mr-4" }, " Your dashboard gives you views of key performance or business process ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon iq-icon-box-2 bg-info-light" }, [
                              _createElementVNode("img", {
                                src: "assets/images/product/1.png",
                                class: "img-fluid",
                                alt: "image"
                              })
                            ], -1)),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.membershipFeePaid ? 'Inviting Friends and Get Rewarded Immediately' : 'Pay Membership Fee to Unlock Features'), 1)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            (_ctx.membershipFeePaid)
                              ? (_openBlock(), _createElementBlock("button", _hoisted_19, " Refer a Friend "))
                              : (_openBlock(), _createBlock(_component_router_link, {
                                  key: 1,
                                  to: "/membership-fee",
                                  class: "btn btn-primary view-btn font-size-14"
                                }, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode(" Pay Membership Fee ")
                                  ])),
                                  _: 1
                                }))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_router_view, { name: "dashboardItem" })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"card card-transparent card-block card-stretch mb-4\" data-v-815617f6><div class=\"card-header d-flex align-items-center justify-content-between p-0\" data-v-815617f6><div class=\"header-title\" data-v-815617f6><h4 class=\"card-title mb-0\" data-v-815617f6>Your Virtual Wallets</h4></div><div class=\"card-header-toolbar d-flex align-items-center\" data-v-815617f6></div></div></div>", 1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "card-title" }, "Dalto Investments", -1)),
                          _createElementVNode("div", null, [
                            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "wallet-type mb-0" }, "USDT Wallet Address", -1)),
                            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.user?.usdt_wallet || "N/A"), 1)
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.user?.first_name) + " " + _toDisplayString(_ctx.user?.last_name), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg-danger-light rounded" }, [
                        _createElementVNode("img", {
                          src: "assets/images/product/05.png",
                          class: "style-img img-fluid m-auto",
                          alt: "image"
                        })
                      ], -1)),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("p", _hoisted_33, "Your Wallet: " + _toDisplayString(_ctx.walletAmount) + " USDT", 1),
                        _createElementVNode("p", _hoisted_34, "USDT Wallet Address: " + _toDisplayString(_ctx.user?.usdt_wallet || "N/A"), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
    ])
  ]))
}